import { confirmSignIn, fetchAuthSession, signIn } from 'aws-amplify/auth';
import config from '~/config';
import { g } from '~/globals';
import { gqlMutationClient } from '~/lib/backend';
import { authStateAtom } from '~/state/auth';

/**
 * Cognito with custom auth flow has been a REAL PAIN THE ASS!!!!
 *
 * THIS IS A hACK and needs to better integrated
 *
 * @param email
 * @param method
 */
const setMethod = async (email: string, method: 'SMS' | 'EMAIL') => {
  await gqlMutationClient({ dealershiplessAuth: true })({
    setDeliveryMethodForUser: [
      {
        email,
        method
      },
      {
        '...on MutationSetDeliveryMethodForUserSuccess': {
          data: {
            status: true
          }
        },
        '...on GraphQLError': {
          message: true
        }
      }
    ]
  });
};

export const amplifyInitiateSignIn = async (
  email: string,
  method: 'SMS' | 'EMAIL' = 'SMS'
) => {
  if (!config.cognito.clientId) {
    throw new Error('Cognito client id is not set');
  }

  /**
   * If user attempt to login when there is an existing user
   * Throw an error
   */
  const currentUser = await fetchAuthSession();
  if (currentUser.tokens?.accessToken) {
    throw new Error('Cannot log in when another user is logged in.');
  }

  if (method) {
    await setMethod(email, method);
  }

  /**
   * When we call amplify `signIn` without a password authFlowType `CUSTOM_WITHOUT_SRP`
   * This automatically set the user into `Challanged` state
   *
   * This state will make Cognito automatically trigger the customized lambda trigger for Custom Challange
   * See `cognitoCreateAuthChallange` in Pulumi for more details
   */
  await signIn({
    username: email,
    options: {
      authFlowType: 'CUSTOM_WITHOUT_SRP',
      clientMetadata: {
        method
      }
    }
  });
};

export const amplifyConfirmLogin = async (otp: string) => {
  if (!config.cognito.clientId) {
    throw new Error('Cognito client id is not set');
  }

  /**
   * Submit the custom challange response
   */
  const confirmRes = await confirmSignIn({
    challengeResponse: otp
  });

  /**
   * If failed to signIn throw an error
   * This indicates the Custom Challenge Answer is Invalid
   */
  if (
    !confirmRes.isSignedIn &&
    confirmRes.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE'
  ) {
    throw new Error('Invalid OTP');
  }

  /**
   * Fetch the session from Amplify to get the tokens to Integrate with Existing Auth Structure
   */
  const session = await fetchAuthSession();

  if (!session.tokens?.accessToken || !session.tokens?.idToken) {
    throw new Error("Can't login invalid session token");
  }

  // Currently we use this to discriminate between the authentication methods we have.
  // However, this is deprecated, the authStateAtom should only be used for the customer.
  g.reg.jotaiStore.set(authStateAtom, session);
};
